import {Devis} from '@/models';

export default [
	{
		path: '/devis',
		name: 'devis',
		meta: {
			title: 'Liste des devis',
			granted: [ 'API_GET_CLIENT' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Devis.vue')
	},
	{
		path: '/devis/show/:id',
		name: 'devis-show',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Devis/Show.vue'),
				class: Devis
			}),
			editRoute: { name: 'devis-edit' },
		},
		meta: {
			title: 'Détail d\'un devis',
			granted: [ 'API_GET_CLIENT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
	{
		path: '/devis/edit/:id',
		name: 'devis-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Devis/Edit.vue'),
				class: Devis
			}),
		},
		meta: {
			title: 'Edition d\'un devis',
			granted: [ 'API_PUT_CLIENT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];